import { Component } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { Meta  } from './common/seo.service';
import { FillerService } from './common/Service_tnFiller';

@Component({
  selector: 'app-root',
  templateUrl: `./app.component.html`,   
  styleUrls: ['./app.component.scss'],
  providers: [ Meta, FillerService ] 
})

export class AppComponent {
  
  MenuAboutUs: any;
  currentUrl: string;

  public constructor(private myMeta: Meta, private router: Router) {    
    myMeta.setTitle('Titolo modificato in runtime');

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });

    //myMeta.updateMeta('description', 'Descrizione della mia pagina modificata in runtime');
    this.MenuAboutUs = 'che bella roba';

  } 
  
}


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/app.component.ts